'use client';
import AcceptedCookies from '@/types/AcceptedCookies';
import { COOKIE_LIFETIME } from '@/app-preferences';

class CookieManager {
	static cookie_expiration: number = COOKIE_LIFETIME;
	static consent_cookie_name = 'consent_preferences';

	static setCookie(key: string, value: string) {
		this.saveCookies(key, value);
	}

	static isCookieExists(cookieName: string) {
		return document.cookie.includes(cookieName);
	}

	static isConsentCookieExists() {
		return this.isCookieExists(this.consent_cookie_name);
	}

	static saveCookies(key: string, value: string) {
		const d = new Date();
		d.setTime(d.getTime() + this.cookie_expiration * 100);
		document.cookie = `${key}=${value}; Expires=${d.toUTCString()}; Path=/`;
	}

	static updateCookieConsent(consentCookie: AcceptedCookies) {
		const cookieString = encodeURIComponent(
			JSON.stringify({ ...consentCookie, timeStamp: Date.now() })
		);
		this.saveCookies(this.consent_cookie_name, cookieString);
	}

	static getConsent() {
		const name = this.consent_cookie_name + '=';
		for (const part of document.cookie.split(';')) {
			const cookie = part.trim();
			if (cookie.startsWith(name)) {

				return decodeURIComponent(cookie.substring(name.length));
			}
		}
	}
}

export default CookieManager;
